import React, { FC } from 'react';
import { Box } from '@bechtel/gds';
import { Text } from '@bechtel/gds';
import { Heading } from '@bechtel/gds';
import { useWorkPackage } from '~/detail/context';
import { useDateRange } from '@bechtel/client-common';

export const WorkPackageHeaderDetail: FC = () => {
  const { tag, startDate, endDate } = useWorkPackage();
  const [dateRangeLabel, dateDistance] = useDateRange(startDate, endDate);

  return (
    <Box p={{ sm: '600' }} flexDirection={{ sm: 'column' }}>
      <Box mb={{ sm: '200' }}>
        <Heading size="600" color="white" weight="600" transform="uppercase">
          {tag}
        </Heading>
      </Box>
      <Text size="400" color="white">
        {dateRangeLabel} {dateDistance}
      </Text>
    </Box>
  );
};
